module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/tydligaretal_100x56-b818d27db492fa6f747d39ec2d7195b6.png";